let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g6xo3")).then(() => parcelRequire('cUgAc'));